import React from 'react'

import Header from '../../components/Header'

import Img11 from '../../assets/ilustracao_tela11.png'

import { Container, Content, Line } from './styles'
import usePersistedState from '../../hooks/usePersistedState'
import { AccessionConfigData } from '../../utils/interfaces'
import { DEFAULT_ACCESSION_CONFIG } from '../../utils/accessionConfig'

const End: React.FC = () => {
  const [accessionConfig] = usePersistedState<AccessionConfigData>(
    'accessionConfig',
    DEFAULT_ACCESSION_CONFIG,
  )

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>
            Seu pedido de adesão ao Plano BASF Previdência foi enviado com
            sucesso!
          </strong>

          <img src={Img11} alt="img11" />

          <p>
            Vamos avaliar sua solicitação e em breve você receberá a confirmação
            da adesão por e-mail.
          </p>
          <Line />
          <div>
            <strong>Acesse o nosso site:</strong>
            <a href={accessionConfig.urlSite}>
              {accessionConfig.urlSite}
            </a>
          </div>
        </Content>
      </Container>
    </>
  )
}

export default End
